const formatDate = (value) => {
  if (!value) return "-";

  return new Date(
    `${value}T00:00:00`
  ).toLocaleDateString("es-CO");
};

export default function InvoiceFiscalCard({
  invoiceSettings,
  company,
}) {
  return (
    <section className="invoice-data-card">
      <h3>Información fiscal</h3>

      <dl>
        <div>
          <dt>Prefijo</dt>
          <dd>{invoiceSettings?.invoice_prefix || "-"}</dd>
        </div>

        <div>
          <dt>Resolución</dt>
          <dd>{invoiceSettings?.resolution_number || "-"}</dd>
        </div>

        <div>
          <dt>Vigencia</dt>
          <dd>
            {formatDate(invoiceSettings?.valid_from)} —{" "}
            {formatDate(invoiceSettings?.valid_until)}
          </dd>
        </div>

        <div>
          <dt>Régimen</dt>
          <dd>{company?.tax_regime || "-"}</dd>
        </div>

        <div>
          <dt>Responsabilidad</dt>
          <dd>{company?.tax_responsibility || "-"}</dd>
        </div>

        <div>
          <dt>Actividad</dt>
          <dd>{company?.economic_activity || "-"}</dd>
        </div>
      </dl>
    </section>
  );
}